// Extrae los parámetros `hint_*` del querystring y los inyecta en el
// `data.form` antes de renderizar — sirve para precargar campos del
// form cuando el cliente o el flow de KC pasa, p.ej., `?hint_email=...`.
// La key que llega al form es la parte tras `hint_` (p.ej. `hint_email`
// → `form.email`).
//
// El mecanismo es genérico (cualquier `hint_*`); en producción hoy sólo
// se usa `hint_email`, pero el bucle es 1:1 con el legacy para no
// asumir.

import type { KcDataForm } from "./kcData";

export function applyHints(form: KcDataForm, search: string): KcDataForm {
  const sp = new URLSearchParams(search);
  const next: KcDataForm = { ...form };
  for (const [key, value] of sp.entries()) {
    if (key.startsWith("hint_")) {
      next[key.substring(5)] = value;
    }
  }
  return next;
}
